import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2988d418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "headert" }
const _hoisted_2 = {
  style: {"padding-bottom":"0"},
  class: "navbar navbar-1 navbar-expand-lg navbar-light py-0"
}
const _hoisted_3 = { class: "container-fluid child-div" }
const _hoisted_4 = { href: "https://em.techandover.com/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<button class=\"navbar-toggler\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarSupportedContent\" aria-controls=\"navbarSupportedContent\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" data-v-2988d418><span class=\"navbar-toggler-icon\" data-v-2988d418></span></button><div class=\"collapse navbar-collapse\" id=\"navbarSupportedContent\" data-v-2988d418><ul class=\"navbar-nav ms-auto mb-2 mb-lg-0\" data-v-2988d418><li class=\"nav-item\" data-v-2988d418><a class=\"nav-link nav-linkks link-a px-lg-3\" aria-current=\"page\" href=\"https://em.techandover.com/\" data-v-2988d418>HOME</a></li><li class=\"nav-item\" data-v-2988d418><a class=\"nav-link nav-linkks px-lg-3 link-b\" href=\"https://em.techandover.com/contact/\" data-v-2988d418>CONTACT US</a></li><li class=\"nav-item\" data-v-2988d418><a class=\"nav-link nav-linkks px-lg-3 link-c\" href=\"https://emerture.netlify.app/sign-in\" data-v-2988d418>LOGIN/REGISTER</a></li></ul></div>", 2)
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {"padding":"0px !important","margin-top":"0px"},
  class: "text-white"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  style: {"font-size":"36px","line-height":"1","letter-spacing":"0.04em","font-weight":"700"},
  class: "text-white text-center mt-8rem"
}, " LOGIN ", -1))
const _hoisted_10 = {
  style: {"max-width":"600px"},
  class: "bg-white rounded shadow-sm p-10 p-lg-15 mx-auto"
}
const _hoisted_11 = { class: "mb-10 text-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Create an Account", -1))
const _hoisted_13 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Sign in here ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/google-icon.svg",
  class: "h-20px me-3"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Sign in with Google ")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/svg/brand-logos/linkedin.svg",
  class: "h-20px me-3"
}, null, -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Sign in with LinkedIn ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-gray-400 fs-7 mx-2" }, "OR"),
  /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" })
], -1))
const _hoisted_23 = { class: "row fv-row mb-7" }
const _hoisted_24 = { class: "col-xl-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "First Name", -1))
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "col-xl-6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Last Name", -1))
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "fv-row mb-7" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Email", -1))
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = {
  class: "mb-10 fv-row",
  "data-kt-password-meter": "true"
}
const _hoisted_37 = { class: "mb-1" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, " Password ", -1))
const _hoisted_39 = { class: "position-relative mb-3" }
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center mb-3",
  "data-kt-password-meter-control": "highlight"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2" }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1 bg-secondary bg-active-success rounded h-5px" })
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Use 8 or more characters with a mix of letters, numbers & symbols. ", -1))
const _hoisted_44 = { class: "fv-row mb-5" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Confirm Password", -1))
const _hoisted_46 = { class: "fv-plugins-message-container" }
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { class: "fv-row mb-10" }
const _hoisted_49 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_50 = { class: "form-check-label fw-bold text-gray-700 fs-6" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" I accept the ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Terms and conditions")
const _hoisted_53 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_54 = { class: "text-center" }
const _hoisted_55 = ["data-kt-indicator"]
const _hoisted_56 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_57 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_60 = [
  _hoisted_58,
  _hoisted_59
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              class: "nav-logoo",
              src: require('@/assets/img/emerture.png'),
              alt: "logo"
            }, null, 8, _hoisted_5)
          ]),
          _hoisted_6
        ])
      ]),
      _hoisted_8,
      _hoisted_9
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        novalidate: "novalidate",
        onSubmit: _ctx.onSubmitRegister,
        id: "kt_login_signup_form",
        "validation-schema": _ctx.registration
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_router_link, {
                to: "/sign-in",
                class: "link-primary fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.googleLogin && _ctx.googleLogin(...args))),
            class: "btn btn-light-primary fw-bolder w-100 mb-10"
          }, _hoisted_18),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.linkedInLogin && _ctx.linkedInLogin(...args))),
            class: "btn btn-light-primary fw-bolder w-100 mb-10"
          }, _hoisted_21),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "",
                name: "firstName",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_ErrorMessage, { name: "firstName" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "",
                name: "lastName",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_ErrorMessage, { name: "lastName" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "email",
              placeholder: "",
              name: "email",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_ErrorMessage, { name: "email" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("div", _hoisted_39, [
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "password",
                  placeholder: "",
                  name: "password",
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_ErrorMessage, { name: "password" })
                  ])
                ])
              ]),
              _hoisted_42
            ]),
            _hoisted_43
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "password",
              placeholder: "",
              name: "password_confirmation",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("label", _hoisted_49, [
              _createVNode(_component_Field, {
                class: "form-check-input",
                type: "checkbox",
                name: "toc",
                value: "1"
              }),
              _createElementVNode("span", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_router_link, {
                  to: "/terms-and-conditions",
                  class: "ms-1 link-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_52
                  ]),
                  _: 1
                }),
                _hoisted_53
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              id: "kt_sign_up_submit",
              ref: "submitButton",
              type: "submit",
              class: "btn btn-lg btn-primary"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_56, " Submit "))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _hoisted_60))
                : _createCommentVNode("", true)
            ], 8, _hoisted_55)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}